import React, { useState } from "react";

/**
 * @typedef {Object} BlogImageProps
 * @property {string} src
 * @property {string} alt
 * @property {string} className
 * @property {string} containerClassName
 * @property {boolean} showOverlay
 * @property {() => void} onLoad
 */

/**
 * @param {BlogImageProps} props
 * @returns {React.ReactNode}
 */
export const BlogImage = ({
  src,
  alt,
  className = "w-full h-full object-cover",
  containerClassName = "",
  showOverlay = false,
  onLoad,
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleLoad = () => {
    setImageLoaded(true);
    onLoad?.();
  };

  return (
    <div className={`relative overflow-hidden ${containerClassName}`}>
      {!imageLoaded && (
        <div className="absolute inset-0 bg-gradient-to-br from-gray-200 via-gray-100 to-gray-200 animate-pulse" />
      )}
      <img
        src={src}
        alt={alt}
        className={`transition-transform duration-700 group-hover:scale-110 ${className}`}
        onLoad={handleLoad}
        loading="lazy"
      />
      {showOverlay && (
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      )}
    </div>
  );
};
